import React, { useState, useEffect } from 'react';
// import notification from 'antd/lib/notification';
// import Button from 'antd/lib/button';
// import { validateVersion, createVersion } from '../../API';
// import { config } from '../../config';

import PiConsole from '../PiConsole/PiConsole';

import lightVars from '../../light.json';
import darkVars from '../../dark.json';

// const { REACT_APP_BUILD_ENV, REACT_APP_ID } = config;

const Main = () => {
  const [theme, setTheme] = useState('');

  // const refresh = () => {
  //   window.location.reload();
  // };

  const changeTheme = () => {
    let vars = {};
    let newTheme = '';

    if (theme === 'light') {
      vars = darkVars;
      newTheme = 'dark';
    } else {
      vars = lightVars;
      newTheme = 'light';
    }

    localStorage.setItem('app-theme', JSON.stringify(vars));
    localStorage.setItem('theme-name', newTheme);
    window.less.modifyVars(vars);
    setTheme(newTheme);
  };

  // const checkVersion = async () => {
  //   const versionNumber = process.env.REACT_APP_VERSION;

  //   const versionValidateObj = await validateVersion(REACT_APP_BUILD_ENV, versionNumber, REACT_APP_ID);

  //   const { is_latest: isLatest, should_create: shouldCreate } = versionValidateObj;

  //   if (!isLatest) {
  //     if (shouldCreate) {
  //       createVersion(REACT_APP_BUILD_ENV, true, versionNumber, REACT_APP_ID);
  //     } else {
  //       // Refresh
  //       const btn = (
  //         <Button type="primary" size="small" onClick={() => refresh()}>
  //           Refresh
  //         </Button>
  //       );
  //       notification.info({
  //         placement: 'bottomLeft',
  //         duration: 0,
  //         style: { borderRadius: '8px' },
  //         btn,
  //         message: `Your pi is getting stale`,
  //         description: 'To ensure you have a freshly baked pi, please click the refresh button',
  //       });
  //     }
  //   }
  // };

  useEffect(() => {
    const getCurrentTheme = () => {
      const currentTheme = localStorage.getItem('theme-name');

      if (currentTheme === 'light') {
        localStorage.setItem('app-theme', JSON.stringify(lightVars));
        window.less.modifyVars(lightVars);
        setTheme(currentTheme);
      } else if (currentTheme === 'dark') {
        localStorage.setItem('app-theme', JSON.stringify(darkVars));
        window.less.modifyVars(darkVars);
        setTheme(currentTheme);
      } else {
        localStorage.setItem('theme-name', 'light');
        localStorage.setItem('app-theme', JSON.stringify(lightVars));
        window.less.modifyVars(lightVars);
        setTheme('light');
      }
    };

    getCurrentTheme();
    // checkVersion();
  }, []);

  return <PiConsole theme={theme} changeTheme={changeTheme} />;
};

export default Main;
